// Copyright (c) 2021 WiseTime. All rights reserved.

import { ListDaySummariesRequest } from "../../../generated/wisetime/user/timeline/v4/timeline_pb"

export const prepareListDaySummaryRequest = (activeDate: string): ListDaySummariesRequest => (
  new ListDaySummariesRequest()
    .setStartDate(activeDate)
    .setEndDate(activeDate)
)
